//#region Imports
import { Component, ElementRef, HostListener, inject, OnInit, ViewChild } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FormArray, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators, AbstractControl, ValidationErrors, FormControl } from '@angular/forms';
import { ContactService } from '../../shared/services/static-page/contact.service';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { Router } from '@angular/router';
import { VisaDetailComponent } from '../../shared/components/visa-detail/visa-detail.component';
import { CityService } from '../../shared/services/city/city.service';
import { PLATFORM_ID, Inject } from '@angular/core';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { VisaLevelService } from '../../shared/services/visa-level.service';
import { ProfessionService } from '../../shared/services/profession.service';
import { EducationService } from '../../shared/services/education.service';
import { VisaLanguageService } from '../../shared/services/visa-language.service';
import { ReligionService } from '../../shared/services/religion.service';
import { PasaportModalComponent } from './pasapot-modal/pasaport-modal.compnent';
import { NgbAccordionModule, NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from '../../shared/services/toast/toast.service';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FamilyMembershipService } from '../../shared/services/family-membership.service';
import { trigger, transition, style, animate } from '@angular/animations';
import { VisaService } from '../../shared/services/visa.service';
import { Country, CountryLanguage, CustomerPaymentModel, VisaApplication, VisaCountry, VisaSelect } from '../../shared/Core/visa.data';
import { TextMaskModule } from '@matheo/text-mask';
import { VisaApplicationService } from '../../shared/components/visa-detail/visa-application.service';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { ImageService } from '../../shared/services/image-service/image.service';
import { VisaCountryService } from '../../shared/services/visa-country.service';
import { VisitReasonService } from '../../shared/services/visit-reason.service';
import { VisaTypeService } from '../../shared/services/visa-type.service';
import { LoadingService } from '../../shared/services/Loading/Loading.Service';
import { BankService } from '../../shared/services/bank.service';
import { BankDto } from '../../shared/models/dtos/bankDto';
import { NgxSpinnerService } from 'ngx-spinner';
import { CountryService } from '../../shared/services/country.service';
import { HelpService } from '../../shared/services/helpers/help.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { familyMemberType, familyMemberTypeList } from '../../shared/Core/familyMemberType.data';
import { debounce } from 'lodash';
//#endregion
@Component({
  selector: "app-visa-value",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    VisaDetailComponent,
    SelectDropDownModule,
    PasaportModalComponent,
    TextMaskModule,
    NgbAccordionModule,
    NgxExtendedPdfViewerModule,
    NgSelectModule,
  ],
  providers: [NgbModalConfig, NgbModal, ImageService],
  templateUrl: "./visa-value.component.html",
  styleUrl: "./visa-value.component.scss",
  animations: [
    trigger("slideDownUp", [
      transition(":enter", [
        style({ opacity: 0 }),
        animate("500ms ease-in", style({ opacity: 1 })),
      ]),
      transition(":leave", [animate("500ms ease-out", style({ opacity: 0 }))]),
    ]),
    trigger("enter_leave", [
      transition(":enter", [
        style({ height: "0px", opacity: 0 }),
        animate("300ms ease-out", style({ height: "*", opacity: 1 })),
      ]),
      transition(":leave", [
        animate("300ms ease-in", style({ height: "0px", opacity: 0 })),
      ]),
    ]),
  ],
})
export class VisaValueComponent implements OnInit {
  @ViewChild("pasaportModal") pasaportModal: any;
  @ViewChild("paymentModal") paymentModal: any;
  @ViewChild("previewImageModal") previewImageModal: any;
  @ViewChild("contactModal") contactModal: any;
  private customerIndex$ = new BehaviorSubject<number>(0);
  hideHotelAndTicket: boolean = false;
  isCardFormValid: boolean = false;
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router,
    private cityService: CityService,
    private readonly contactService: ContactService,
    private modalService: NgbModal,
    private bankService: BankService,
  ) {
    this.initForm();
  }

  //-----------------------------------------------------------------------------------------------------
  //#region Services
  _visaCountryService = inject(VisaCountryService);
  _visitReasonService = inject(VisitReasonService);
  _visitTypeService = inject(VisaTypeService);
  _visaLevelService = inject(VisaLevelService);
  _professionService = inject(ProfessionService);
  _educationService = inject(EducationService);
  _visalanguageService = inject(VisaLanguageService);
  _familyMembershipService = inject(FamilyMembershipService);
  _religionService = inject(ReligionService);
  _visaApplicationService = inject(VisaApplicationService);
  _activatedRoute = inject(ActivatedRoute);
  _imageService = inject(ImageService);
  _http = inject(HttpClient);
  _fb = inject(FormBuilder);
  _toast = inject(ToastService);
  _visaService = inject(VisaService);
  _loadingService = inject(LoadingService);
  _bankService = inject(BankService);
  _spinner = inject(NgxSpinnerService);
  _countryService = inject(CountryService);
  _helpService = inject(HelpService);
  //#endregion
  //-----------------------------------------------------------------------------------------------------

  //-----------------------------------------------------------------------------------------------------
  //#region Error messages
  errors = {
    required: "Bu alan zorunludur.",
    minCa: "Bu alan en az 3 karakter olmalıdır.",
    dropdown: "Bu alan zorunludur.",
    email: "Geçerli bir e-posta adresi girin.",
    phoneNumber: "Geçerli bir telefon numarası girin.",
    tCNumber: "Geçerli bir TC kimlik numarası girin.",
    dateInPast: "Geçmiş bir tarih giremezsiniz.",
  };
  //#endregion
  //-----------------------------------------------------------------------------------------------------

  //-----------------------------------------------------------------------------------------------------
  //#region payment variables
  isCardFlipped: boolean = false;
  cc_holder_name = "";
  expiry_month = "";
  expiry_year = "";
  credit_card_no = "";
  cvv = "";
  currency_code = "USD";
  invoice_description = "Test Invoice";
  name = "Yunus";
  surname = "Kaya";
  total = "5.00";
  items =
    '[{"name":"Item3","price":5.00,"qnantity":1,"description":"item3 description"}]';
  //#endregion
  //-----------------------------------------------------------------------------------------------------
  form!: FormGroup;
  isSubmitForm: boolean = false; // formun submit edilip edilmediğini kontrol eden değişken
  mask10 = [
    "(",
    /\d/,
    /\d/,
    /\d/,
    ")",
    " ",
    /\d/,
    /\d/,
    /\d/,
    "-",
    /\d/,
    /\d/,
    /\d/,
    /\d/,
  ]; // 10 haneli telefon numarası için maske
  resultPrice: number = 0; // toplam fiyat dolar
  resultPriceTRY: number = 0; // toplam fiyat lira
  visaPrice: number = 0; // vize fiyatı
  smsPrice: number = 0; // sms fiyatı
  cargoPrice: number = 0; // kargo fiyatı
  calculatePriceDebounced!: (index?: number) => void;
  imagePreview: any = ""; // resim önizleme
  pdfPreview: any = ""; // pdf önizleme

  selectedCountry: VisaCountry = {} as VisaCountry; // ana sayfadan gelen ülke bilgisi
  selectedVisitReason: VisaSelect = {} as VisaSelect; // ana sayfadan gelen vize sebebi bilgisi
  selectedVisaType: VisaSelect = {} as VisaSelect; // ana sayfadan gelen vize tipi bilgisi
  selectedLevel: VisaSelect = {} as VisaSelect; // ana sayfadan gelen vize seviyesi bilgisi

  visaApplicationGuid = ""; // başvuru guid bilgisi
  visaApplicationNumber = ""; // başvuru numarası
  months: string[] = Array.from({ length: 12 }, (_, i) => (i + 1).toString()); // 1-12 ayları
  years: number[] = Array.from(
    { length: 20 },
    (_, i) => new Date().getFullYear() + i,
  ); // 2023-2042 yılları
  banks: BankDto[] = []; // banka listesi
  contact: any; // iletişim bilgileri
  locationLink: any; // iletişim bilgileri için harita linki
  cities: any; // şehir listesi
  whatsappLink: string = "https://wa.me/"; // whatsapp linki

  paymentType: 'creditCard' | 'transfer' = 'creditCard';
  //------------------------------------------------------------------------------------------------------
  showType: showTypes = null as any; // hangi adımda olduğumuzu belirten değişken
  childType: childTypes = null as any; // hangi adımda olduğumuzu belirten değişken
  childTypes = childTypes; // childTypes enum
  showTypes = showTypes; // showTypes enum
  //------------------------------------------------------------------------------------------------------

  invoiceType: invoiceTypes = invoiceTypes.individual; // fatura tipi
  // hangi müşterinin bilgilerini gösterdiğimizi belirten değişken

  professions: { id: number; name: string }[] = []; // Meslek seçenekleri
  languages: { id: number; name: string }[] = []; // Dil seçenekleri
  educations: { id: number; name: string }[] = []; // Eğitim seçenekleri
  religions: { id: number; name: string }[] = []; // Din seçenekleri
  groupMemberships: { id: number; name: string }[] = familyMemberTypeList;
  familyMemberTypes: { id: number; name: string }[] = [];  // Aile üyeliği seçenekleri
  countries: CountryLanguage[] = []; // Ülke seçenekleri
  visaCountries: VisaCountry[] = []; // Vize ülkeleri
  visitReasons: VisaSelect[] = []; // Vize sebebi seçenekleri
  visaTypes: VisaSelect[] = []; // Vize tipi seçenekleri
  visaLevels: { id: number; name: string }[] = []; // Vize seviyesi seçenekleri
  maritalStatuses: { id: number; name: string }[] = [
    {
      id: 0,
      name: "Seçiniz",
    },
    {
      id: 1,
      name: "Bekar",
    },
    {
      id: 2,
      name: "Evli",
    },
  ];
  contactPerson: any = {
    firstName: "",
    lastName: "",
  };
  applicationTypes: { id: number; name: string }[] = [
    {
      id: 0,
      name: "Seçiniz",
    },
    {
      id: 1,
      name: "Bireysel",
    },
    {
      id: 2,
      name: "Aile",
    },
  ];
  contactPersons: {
    id: number;
    firstName: string;
    lastName: string;
    contactCustomerPassport_No: string;
    contactCustomerTC_No: string;
  }[] = [];
  set customerIndex(value: number) {
    this.customerIndex$.next(value);
  }

  get customerIndex(): number {
    return this.customerIndex$.value;
  }
  //------------------------------------------------------------------------------------------------------
  // Tarayıcı geri tuşuna basıldığında çalışacak fonksiyon
  @HostListener("window:popstate", ["$event"])
  onPopState(event: PopStateEvent) {
    this.resetForm();
  }
  //------------------------------------------------------------------------------------------------------
  async ngOnInit(): Promise<void> {
    // SSR kontrolü ekleyin
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    this.calculatePriceDebounced = debounce((index: number = 0) => {
      this.calculatePrice(index);
    }, 500);

    //------------------------------------------------------------------------------------------------------
    // burada kontrol ediyorum eğer mrzden bir hata gelirse sayfayı yenileyecek
    const body = document.body;
    const mrzWorker = body.querySelector("mrz_worker");
    if (mrzWorker) {
      window.location.reload();
    }
    //------------------------------------------------------------------------------------------------------
    this.getDataFromJS(); // java scriptten gelen veriyi alıyorum
    //------------------------------------------------------------------------------------------------------
    // burada url parametrelerini alıyorum eğer id varsa başvuru detayını alıyorum yoksa ilk adıma yönlendiriyorum
    this._activatedRoute.queryParams.subscribe((params) => {
      if (!this.router.url.includes("visa")) {
        this.resetForm();
      }
      const id = params["id"];
      const type = params["type"];
      if (id) {
        this.getById(id);
      } else if (type == "firstStep") {
        this.resetForm();
        this.initForm();
        this.showType = showTypes.firstStep;
        this.childType = childTypes.country;
        this.patchfirstStepData();
      } else {
        this.controlFirstStep();
        this.patchfirstStepData();
        this.showType = showTypes.pasaportStep;
      }
    });
    //------------------------------------------------------------------------------------------------------
    this.init(); // burada sayfa için gerekli olan verileri alıyorum
    //------------------------------------------------------------------------------------------------------
    // Ülke listesini alıyorum
    this._countryService.getAll().subscribe((data: CountryLanguage[]) => {
      this.countries = data;
      this.countries.unshift({
        id: 0,
        name: "Seçiniz",
        baseId: 0,
        country: {} as Country,
        languageId: 0,
      });
    });
    //------------------------------------------------------------------------------------------------------
    // İletişim bilgilerini al
    let data = await firstValueFrom(this.contactService.getContact());
    this.contact = data[0];
    const regex = /src="([^"]*)"/;
    const match = this.contact.locationLink.match(regex);
    this.locationLink = match ? match[1] : null;
    //------------------------------------------------------------------------------------------------------
    await this.loadBanks(); // Banka bilgilerini alıyorum
  }

  //-----------------------------------------------------------------------------------------------------
  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    this._helpService
      .loadScript("assets/js/mrz-worker.bundle-min-wrapped.js")
      .then(() => {
        // İlk script yüklendiğinde çalışır
        return this._helpService.loadScript("assets/js/demo.bundle.js");
      })
      .then(() => { })
      .catch((error) => {
        console.error("Script yükleme hatası:", error);
      });

    window.addEventListener(
      "message",
      (event) => {
        if (event.data?.type != 'paymentResult') {
          return;
        }
        // Güvenlik için sadece beklenen domain'den gelen mesajları kabul et
        //const allowedOrigins = ['https://www.vizeasist.com', 'https://vizeasist.com', 'https://test.vizeasist.com', 'http://localhost:42511', 'http://localhost:3000'];
        //if (!allowedOrigins.includes(event.origin)) return;
        if (event.data?.status === 'success') {
          this._toast.Success('Ödemeniz başarıyla gerçekleşti.');
          clearInterval(this.checkIframeStatusInterval);
          this.modalService.dismissAll();
          this.showType = showTypes.result;
        } else if (event.data?.status === "error") {

          let error = event.data.errorMessage || "Ödeme başarısız. Kart bilgilerinizi kontrol ediniz.";
          if (this.errorList.some((item) => error?.includes(item))) {
            error = error
              .replace("Transaction Pending", "Kart Bilgileri Hatalı")
              .replace("Pos", "Kart Bilgileri Hatalı")
              .replace("cc no", "Kart Numarası Hatalı")
              .replace("cc holder name", "Kart Sahibi Adı Hatalı")
              .replace("expiry month", "Son Kullanma Ayı Hatalı")
              .replace("expiry year", "Son Kullanma Yılı Hatalı")
              .replace(
                "Bu üye işyeri için cvv'siz işlem izin verilmez",
                "Kartınızın CVV kodunu girmeniz gerekmektedir.",
              );

          }
          this._toast.Error(error);
          localStorage.removeItem("sipay_error");
          clearInterval(this.checkIframeStatusInterval);
          this.modalService.dismissAll();
        }
      },
      false,
    );
  }
  //#endregion
  //------------------------------------------------------------------------------------------------------
  // formu sıfırlıyorum ve diğer verileri temizliyorum
  resetForm() {
    this.form.reset();
    this._visaService.setVisaCountry({} as VisaCountry);
    this._visaService.setVisitReason({} as VisaSelect);
    this._visaService.setVisaType({} as VisaSelect);
    this.resultPrice = 0;
    this.resultPriceTRY = 0;
    this.smsPrice = 0;
    this.cargoPrice = 0;
    this.visaPrice = 0;
  }
  //------------------------------------------------------------------------------------------------------
  getDataFromJS() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    window.addEventListener("mrzDataReceived", (event: any) => {

      if (!event?.detail) {
        this._toast.Error("Pasaport bilgisi okunamadı. Lütfen daha iyi bir resim yükleyin.");
        this.clearPassportData();
        return;
      }

      const data = event.detail;
      let index = this.customerIndex$.value;
      const appformGroup = this.customers.at(index) as FormGroup;
      const age = this._helpService.calculateAge(this._helpService.formatYYMMDDToAngularDate(data.birthDate, true,));

      // eğer 18 yaşından küçükse uyarı ver ve geçmesin
      if (age < 18 && index === 0) {
        this._toast.Error("18 yaşından küçükler için başvuru yapılamaz.");
        this.clearPassportData();
        return;
      } else {

        appformGroup.patchValue({
          passport_No: data.pasaportNo,
          firstName: data.firstName,
          lastName: data.lastName,
          nationalityId: this.countries.find((x) => x.country.passportCode === data.nationality,)?.country.id,
          comingFromId: this.countries.find((x) => x.country.passportCode === data.nationality,)?.country.id,
          birthCountryId: this.countries.find((x) => x.country.passportCode === data.nationality,)?.country.id,
          birthDate: this._helpService.formatYYMMDDToAngularDate(data.birthDate, true,),
          dateOfExpiry: this._helpService.formatYYMMDDToAngularDate(data.expirationDate,),
          issuingState: data.issuingState, gender: Number(data.sex),
        });
        if (data.nationality === "TUR") {
          appformGroup.patchValue({ tC_Number: data.personalNumber, });
        }
        this.calculatePriceDebounced(index);
      }
      setTimeout(() => {
        this._spinner.hide();
      }, 1000);
    });
  }
  //#endregion
  //------------------------------------------------------------------------------------------------------
  checkIframeStatusInterval: any = null; // iframe durumunu kontrol etmek için interval
  @ViewChild("iframeRef") iframeRef!: ElementRef<HTMLIFrameElement>;

  clearPassportData() {
    let index = this.customerIndex$.value;

    this.customers.at(index).patchValue({
      mRZCode: "",
      passport_No: null,
      firstName: null,
      lastName: null,
      nationalityId: null,
      comingFromId: null,
      birthCountryId: null,
      birthDate: "",
      dateOfExpiry: "",
      issuingState: null,
      gender: null,
      tC_Number: null,
    });

    this.customers.at(index).patchValue({
      mainPassportImage: "",
    });

    this.imagePreview = "";
    const inputElement = document.getElementById("photooo") as HTMLInputElement;
    if (inputElement) {
      inputElement.value = "";
    }

    const mrzElement = document.getElementById("MRZ") as HTMLElement;
    if (mrzElement) {
      mrzElement.innerHTML = "";
    }

    setTimeout(() => { this._spinner.hide(); }, 1000);
  }


  errorList: string[] = [
    "Pos",
    "cc no",
    "cc holder name",
    "expiry month",
    "expiry year",
    "Transaction Pending",
    "Bu üye işyeri için cvv'siz işlem izin verilmez",
  ];
  stopInternal() {
    clearInterval(this.checkIframeStatusInterval);
  }
  //#endregion

  //------------------------------------------------------------------------------------------------------
  // burada sadece form içindeki müşteri arrayini alıyorum atama yapabilmek için
  get customers() {
    return this.form.get("customers") as FormArray;
  }
  //------------------------------------------------------------------------------------------------------

  //------------------------------------------------------------------------------------------------------
  //#region Custom Validators
  phoneNumberValidator(control: AbstractControl): ValidationErrors | null {
    if (!control.value) {
      return null; // required validator zaten var
    }

    // Maskelenmiş değeri al ve sadece rakamları çıkar
    const phoneValue = control.value.replace(/\D/g, "");

    // 10 haneli olup olmadığını kontrol et
    if (phoneValue.length !== 10) {
      return { phoneNumberInvalid: true };
    }

    return null;
  }
  //#endregion
  //------------------------------------------------------------------------------------------------------

  //------------------------------------------------------------------------------------------------------
  //#region initForm()
  initForm() {
    this.form = this._fb.group({
      guid_Id: [null],
      apllicationNumber: [null],
      applicationType: [1, [Validators.required, Validators.min(1)]],
      visaCountryId: [0, Validators.required],
      visaTypeId: [0],
      visaLevelId: [0, [Validators.required, Validators.min(1)]],
      visitReasonId: [0, [Validators.required, Validators.min(1)]],
      arrivalDate: ["", [Validators.required, this._helpService.checkDate]],
      email: [null, [Validators.required, Validators.email]],
      phoneNumber: [null, [Validators.required, this.phoneNumberValidator]],
      cityId: [0, Validators.required],
      contactCustomerPassport_No: ["", Validators.required],
      contactCustomerTC_No: [""],
      invoice_FirstName: [""],
      invoice_District: [""],
      invoice_City: [""],
      invoice_LastName: [""],
      invoice_Title: [""],
      invoice_Address: [""],
      invoice_TaxNumber: [""],
      invoice_TaxOffice: [""],
      invoice_TCNumber: [""],
      deliveryAddress: [""],
      invoiceType: [this.invoiceType],
      customers: this._fb.array([]),
      totalAmount: [0],
      sendSMS: [false], // SMS gönderimi için checkbox
      sendCargo: [false],
      kvkk: [false, Validators.requiredTrue], // KVKK onayı için checkbox
      isInvoiceSaved: [false], // Fatura kaydedildi mi?
      isInvoiceEditable: [false], // Fatura düzenlenebilir mi?
      oneTimePaymentApproval: [false], // Tek seferlik ödeme onayı için checkbox
    });
    this.addMember();
  }
  //#endregion
  //------------------------------------------------------------------------------------------------------

  //------------------------------------------------------------------------------------------------------
  //#region init function()
  init() {
    this.cityService.getList().subscribe((data) => {
      this.cities = data;
      this.cities.unshift({
        id: 0,
        name: "Şehir Seçiniz",
      });
    });

    this._visaCountryService.getAll().subscribe((data: VisaCountry[]) => {
      this.visaCountries = data;
    });
  }
  //#endregion
  //------------------------------------------------------------------------------------------------------

  //------------------------------------------------------------------------------------------------------
  async onCountryChange(id: number) {
    if (id === 51) {
      this.hideHotelAndTicket = true;
      this.groupMemberships = familyMemberTypeList.filter((x) => x.countryId === 51 || x.countryId === undefined);
      this.customers.controls.forEach((customer) => {
        customer.get("returnTicketUrl")?.clearValidators();
        customer.get("returnTicketUrl")?.updateValueAndValidity();
        customer.get("hotelReservationUrl")?.clearValidators();
        customer.get("hotelReservationUrl")?.updateValueAndValidity();
      });
    } else {
      this.hideHotelAndTicket = false;
      this.groupMemberships = familyMemberTypeList.filter((x) => x.countryId === id || x.countryId === undefined);
      this.customers.controls.forEach((customer) => {
        customer.get("returnTicketUrl")?.setValidators([Validators.required]);
        customer.get("returnTicketUrl")?.updateValueAndValidity();
        customer.get("hotelReservationUrl")?.setValidators([Validators.required]);
        customer.get("hotelReservationUrl")?.updateValueAndValidity();
      });
    }
    this.customers.updateValueAndValidity();
    this.form.updateValueAndValidity();
    this._visitReasonService.getByCountryId(id).subscribe((data) => {
      this.visitReasons = data;
    });
    if (this.selectedVisitReason.id > 0) {
      this._visitTypeService
        .getByCountryId(id, this.selectedVisitReason.id)
        .subscribe((data) => {
          this.visaTypes = data;
        });
    }
    this._religionService.getByCountryId(id).subscribe((data) => {
      this.religions = data.map((item: any) => {
        return { id: item.id, name: item.name };
      });
      this.religions.unshift({
        id: 0,
        name: "Seçiniz",
      });
    });
    this._visaLevelService.getByCountryId(id).subscribe((data) => {
      this.visaLevels = data.map((item: any) => {
        return { id: item.id, name: item.name };
      });
      this.visaLevels.unshift({
        id: 0,
        name: "Seçiniz",
      });
    });
    this._professionService.getByCountryId(id).subscribe((data) => {
      this.professions = data.map((item: any) => {
        return { id: item.id, name: item.name };
      });
      this.professions.unshift({
        id: 0,
        name: "Seçiniz",
      });
    });
    this._familyMembershipService.getByCountryId(id).subscribe((data) => {
      this.familyMemberTypes = data.map((item: any) => {
        return { id: item.id, name: item.name };
      });
      this.familyMemberTypes.unshift({
        id: 0,
        name: 'Seçiniz',
      });
    });
    this._educationService.getByCountryId(id).subscribe((data) => {
      this.educations = data.map((item: any) => {
        return { id: item.id, name: item.name };
      });
      this.educations.unshift({
        id: 0,
        name: "Seçiniz",
      });
    });
    this._visalanguageService.getByCountryId(id).subscribe((data) => {
      this.languages = data.map((item: any) => {
        return { id: item.id, name: item.name };
      });
      this.languages.unshift({
        id: 0,
        name: "Seçiniz",
      });
    });
  }
  //-------------------------------------------------------------------------------------------------------
  controlFirstStep() {
    this._visaService.visaCountry$.subscribe((country) => {
      this.selectedCountry = country;
    });
    this._visaService.visitReason$.subscribe((reason) => {
      this.selectedVisitReason = reason;
    });
    this._visaService.visaType$.subscribe((type) => {
      this.selectedVisaType = type;
    });
    if (
      !this._helpService.hasValue(this.selectedCountry) ||
      !this._helpService.hasValue(this.selectedVisitReason)
    ) {
      this.router.navigate(["/"]);
    }
  }
  //-------------------------------------------------------------------------------------------------------
  patchfirstStepData() {
    this._visaService.visaCountry$.subscribe(async (country) => {
      this.selectedCountry = country;
      if (this.selectedCountry.id > 0) {
        await this.onCountryChange(this.selectedCountry.id);
      }
    });
    this._visaService.visitReason$.subscribe((reason) => {
      this.selectedVisitReason = reason;
    });
    this._visaService.visaType$.subscribe((type) => {
      this.selectedVisaType = type;
    });
    this.form.patchValue({
      visaCountryId: this.selectedCountry.id,
      visitReasonId: this.selectedVisitReason.id,
      visaTypeId: this.selectedVisaType.id ?? null,
    });
    if (this.selectedCountry?.id === 51) {
      this.customers.controls.forEach((customer) => {
        customer.get("returnTicketUrl")?.clearValidators();
        customer.get("hotelReservationUrl")?.clearValidators();
        customer.updateValueAndValidity();
      });
    } else {
      this.customers.controls.forEach((customer) => {
        customer.get("returnTicketUrl")?.setValidators([Validators.required]);
        customer.get("hotelReservationUrl")?.setValidators([Validators.required]);
        customer.updateValueAndValidity();
      });
    }
    this.calculatePriceDebounced();
  }
  //-------------------------------------------------------------------------------------------------------
  async choose(id: number, name: string) {
    switch (name) {
      case "country":
        const country = this.visaCountries.find((x) => x.id === id) || ({} as VisaCountry);
        this.onCountryChange(country.id);
        this.selectedCountry = country;
        this._visaService.setVisaCountry(country);
        this.childType = childTypes.visaReason;
        break;

      case "reason":
        const reason = this.visitReasons.find((x) => x.id === id) || ({} as VisaSelect);
        this._visaService.setVisitReason(reason);
        this.selectedVisitReason = reason;
        this.onCountryChange(this.selectedCountry.id);
        
        if (
          this.selectedCountry?.id === 51 &&
          (!this.visaTypes || this.visaTypes.length === 0)
        ) {
          this.showType = showTypes.pasaportStep;
        } else {
          this.childType = childTypes.visaType;
        }
        break;

      case "type":
        const type = this.visaTypes.find((x) => x.id === id) || ({} as VisaSelect);
        this._visaService.setVisaType(type);
        this.showType = showTypes.pasaportStep;
        break;
    }
    this.patchfirstStepData();
  }
  //-------------------------------------------------------------------------------------------------------
  childBack() {
    const newData = {} as VisaSelect;
    const newCountry = {} as VisaCountry;
    if (this.childType === childTypes.visaType) {
      // sıfırla
      this._visaService.setVisitReason(newData);
      // arkaya gel
      this.childType = childTypes.visaReason;
    } else {
      // sıfırla
      this._visaService.setVisaCountry(newCountry);
      // arkaya gel
      this.childType = childTypes.country;
    }
  }
  //-------------------------------------------------------------------------------------------------------
  paymentCustomers: CustomerPaymentModel[] = []; // Ödeme için müşteri bilgileri
  calculatePrice(index: number = 0) {
    const url = environment.apiUrl + '/VisaApplication/GetPrice';
    const isSms = this.form.get('sendSMS')?.value || false;
    const isCargo = this.form.get('sendCargo')?.value || false;
    const visaTypeId = this.form.get('visaTypeId')?.value || 0;
    const visaLevelId = this.form.get('visaLevelId')?.value || 0;
    const visaReasonId = this.form.get('visitReasonId')?.value || 0;
    const countryId = this.form.get('visaCountryId')?.value || 0;
    const applicationType = this.form.get('applicationType')?.value || 1; // burada 1 bireysel 2 aile olarak ayarladım
    const headers = new HttpHeaders({
      skipLoad: "true",
    });
    this.paymentCustomers = this.customers.value.map((customer: any, index: number) => {
      const age = this._helpService.calculateDate_Age(customer.birthDate);
      return { age };
    });

    this._http
      .post(url + `?countryId=${countryId}&isSms=${isSms}&isCargo=${isCargo}&visaTypeId=${visaTypeId}&visaLevelId=${visaLevelId}&visaReasonId=${visaReasonId}&applicationType=${applicationType}`, this.paymentCustomers, {
        headers: headers,
      })
      .subscribe((response: any) => {
        if (response) {
          this.resultPrice = Number(response.visaPrice) + Number(response.smsPrice) + Number(response.cargoPrice);
          this._http.get<Number>(environment.apiUrl + '/Payment/TRExchangeRate', { headers }).subscribe((response: Number) => {
            this.resultPriceTRY = this.resultPrice * Number(response);
          });
          this.visaPrice = Number(response.visaPrice);
          this.smsPrice = Number(response.smsPrice);
          this.cargoPrice = Number(response.cargoPrice);
          this.form.patchValue({
            totalAmount: this.resultPrice,
          });
        }
      });
  }

  getPriceByGuid() {
    const guid = this.form.get("guid_Id")?.value || "";
    const isSms = this.form.get("sendSMS")?.value || false;
    const isCargo = this.form.get("sendCargo")?.value || false;
    const url = environment.apiUrl + "/VisaApplication/GetPriceByGuid";
    const headers = new HttpHeaders({
      skipLoad: "true",
    });
    this._http
      .get(url + `?guid=${guid}&isSms=${isSms}&isCargo=${isCargo}`, { headers })
      .subscribe((response: any) => {
        if (response) {
          this.resultPrice =
            Number(response.visaPrice) +
            Number(response.smsPrice) +
            Number(response.cargoPrice);
          this._http
            .get<Number>(environment.apiUrl + "/Payment/TRExchangeRate", {
              headers,
            })
            .subscribe((response: Number) => {
              this.resultPriceTRY = this.resultPrice * Number(response);
            });
          this.visaPrice = Number(response.visaPrice);
          this.smsPrice = Number(response.smsPrice);
          this.cargoPrice = Number(response.cargoPrice);
          this.form.patchValue({
            totalAmount: this.resultPrice,
          });
        }
      });
  }
  //-------------------------------------------------------------------------------------------------------
  isStepValid(step: number): boolean {
    this.isSubmitForm = true;
    if (step === 1) {
      const appType = this.form.get('applicationType')?.value;
      if (appType === 1) {
        this.customers.controls.forEach((item) => {
          const familyMembershipControl = item.get("familyMembership");
          if (familyMembershipControl) {
            familyMembershipControl.clearValidators(); // Clear validators
            familyMembershipControl.updateValueAndValidity(); // Update validity
          }
        });
      }

      // uyruk kontrolü  ve TC validasyonu
      this.customers.controls.forEach((customer, index) => {
        const nationalityId = customer.get("nationalityId")?.value;
        const tcNumberControl = customer.get("tC_Number");

        if (nationalityId === 792) {
          // Türk vatandaşı için TC zorunlu
          tcNumberControl?.setValidators([
            Validators.required,
            Validators.minLength(11),
            Validators.maxLength(11),
            this.tcNumberValidator(nationalityId),
          ]);
        } else {
          // Yabancı vatandaş için TC opsiyonel
          tcNumberControl?.clearValidators();
        }
        tcNumberControl?.updateValueAndValidity();
      });

      let result =
        this.form.get("applicationType")?.valid &&
        this.form.get("arrivalDate")?.valid &&
        this.customers.controls.every((item, index) => {
          return item.valid;
        });
      // geri kalan tüm alanları kontrol ediyoruz

      if (result) {
        return true;
      }
      return false;
    }

    if (step === 2) {
      return this.customers.controls.every((customer) => customer.valid);
    }

    // Diğer adımlar varsa ekle
    return true;
  }
  //-------------------------------------------------------------------------------------------------------
  birthDate: Date = new Date();
  addMember() {
    this.customers.push(
      this._fb.group({
        mRZCode: [""],
        tC_Number: [null],
        firstName: [null, [Validators.required, Validators.minLength(2)]],
        lastName: [null, [Validators.required, Validators.minLength(2)]],
        gender: [null, Validators.required],
        birthDate: ["", Validators.required],
        birthPlace: [null, Validators.required],
        birthCountryId: [null, Validators.required],
        maritalStatusId: [0, [Validators.required, Validators.min(1)]],
        comingFromId: [null, Validators.required],
        passportIssuePlace: [null, Validators.required],
        passport_No: [null, Validators.required],
        dateOfIssue: [null, Validators.required],
        dateOfExpiry: [{ value: '', disabled: true }, [Validators.required, this._helpService.checkDate]],
        nationalityId: [null, Validators.required],
        professionId: [0, [Validators.required, Validators.min(1)]],
        educationId: [0, [Validators.required, Validators.min(1)]],
        visaLanguageId: [0, [Validators.required, Validators.min(1)]],
        religionId: [0, [Validators.required, Validators.min(1)]],
        familyMemberType: [null],
        mainPassportImage: ["", Validators.required],
        personalImage: ["", Validators.required],
        returnTicketUrl: [""],
        returnTicketName: [""],
        hotelReservationUrl: [""],
        hotelReservationName: [""],
      }),
    );

    // Yeni eklenen müşterinin pasaport geçerlilik tarihini devre dışı bırak
    const lastIndex = this.customers.length - 1;

    // Yeni eklenen müşteri için ülke ID'sine göre validasyon ayarla
    if (this.selectedCountry?.id === 51) {
      this.customers.controls.forEach((customer) => {
        customer.get("returnTicketUrl")?.clearValidators();
        customer.get("returnTicketUrl")?.updateValueAndValidity();
        customer.get("hotelReservationUrl")?.clearValidators();
        customer.get("hotelReservationUrl")?.updateValueAndValidity();
      });
    } else {
      this.customers.controls.forEach((customer) => {
        customer.get("returnTicketUrl")?.setValidators([Validators.required]);
        customer.get("returnTicketUrl")?.updateValueAndValidity();
        customer
          .get("hotelReservationUrl")
          ?.setValidators([Validators.required]);
        customer.get("hotelReservationUrl")?.updateValueAndValidity();
      });
      this.customers.updateValueAndValidity();
      // Form geneli için de güncelleme (gerekirse)
      this.form.updateValueAndValidity();
    }
    // this.customers.at(lastIndex).updateValueAndValidity();

    const countOfMembers = this.customers.length;
    if (countOfMembers > 1) {
      this.calculatePriceDebounced();
    }
  }

  onBirthDateChange(index: number): void {
    const birthDate = this.customers.at(index)?.get('birthDate')?.value;
    const age = this._helpService.calculateAge(birthDate);

    if (index === 0 && age < 18) {
      this._toast.Error("18 yaşından küçükler için başvuru yapılamaz.");
    } else {
      this.calculatePriceDebounced(index);
    }
  }
  //-------------------------------------------------------------------------------------------------------
  deleteMember(index: number) {
    if (this.customers.length > 1) {
      this.customers.removeAt(index);
      this.calculatePriceDebounced();
    } else {
      this._toast.Error("En az bir üye olmalıdır.");
    }
  }
  //-------------------------------------------------------------------------------------------------------
  setOneTimePaymentApproval() {
    const oneTimePaymentApproval = this.form.get(
      "oneTimePaymentApproval",
    )?.value;
    localStorage.setItem(
      "oneTimePaymentApproval",
      JSON.stringify(oneTimePaymentApproval),
    );
  }
  //-------------------------------------------------------------------------------------------------------
  getById(id: string) {
    const url = environment.uploadsUrl;
    this._visaApplicationService
      .getByGuid(id)
      .subscribe((data: VisaApplication) => {
        this.contactPerson.firstName = data.customers.find(
          (x) => x.passport_No == data.contactCustomerPassport_No,
        )?.firstName;
        this.contactPerson.lastName = data.customers.find(
          (x) => x.passport_No == data.contactCustomerPassport_No,
        )?.lastName;

        this._visaCountryService
          .getAll()
          .subscribe((countries: VisaCountry[]) => {
            countries;
            const country =
              countries.find(
                (item: VisaCountry) => item.id == data.visaCountryId,
              ) || ({} as VisaCountry);
            this.selectedCountry = country;
            this._visaService.setVisaCountry(country);
          });
        this._visitReasonService.getAll().subscribe((reasons) => {
          const reason = reasons.find(
            (item: VisaSelect) => item.id == data.visitReasonId,
          );
          this.selectedVisitReason = reason;
          this._visaService.setVisitReason(reason);
        });
        this._visitTypeService.getList().subscribe((visitTypes) => {
          const type = visitTypes.find(
            (item: VisaSelect) => item.id == data.visaTypeId,
          );
          this.selectedVisaType = type;
          this._visaService.setVisaType(type);
        });
        this._visaLevelService.getList().subscribe((visaLevels) => {
          const level = visaLevels.find(
            (item: VisaSelect) => item.id == data.visaLevelId,
          );
          this.selectedLevel = level;
        });
        this.resultPrice = data.totalAmount;
        this.resultPriceTRY = data.totalTr_Amount;
        this.visaApplicationNumber = data.apllicationNumber;
        this.form.patchValue({
          apllicationNumber: data.apllicationNumber,
          applicationType: data.applicationType,
          arrivalDate: data.arrivalDate.substring(0, 10),
          cityId: data.cityId,
          contactCustomerPassport_No: data.contactCustomerPassport_No,
          contactCustomerTC_No: data.contactCustomerTC_No,
          invoiceType: data.invoiceType,
          invoice_FirstName: data.invoice_FirstName,
          invoice_District: data.invoice_District,
          invoice_City: data.invoice_City,
          invoice_LastName: data.invoice_LastName,
          invoice_Address: data.invoice_Address,
          invoice_TaxNumber: data.invoice_TaxNumber,
          deliveryAddress: data.deliveryAddress,
          invoice_TaxOffice: data.invoice_TaxOffice,
          invoice_TCNumber: data.invoice_TCNumber,
          invoice_Title: data.invoice_Title,
          email: data.email,
          guid_Id: data.guid_Id,
          phoneNumber: data.phoneNumber,
          sendSMS: data.sendSMS,
          sendCargo: data.sendCargo,
          visaCountryId: data.visaCountryId,
          visaLevelId: data.visaLevelId,
          visaTypeId: data.visaTypeId,
          visitReasonId: data.visitReasonId,
          isInvoiceEditable: data.isInvoiceEditable,
          isInvoiceSaved: data.isInvoiceSaved,
          kvkk: true,
          customers: data.customers.map((customer: any) => {
            return {
              ...customer,
              birthCountryId: customer.birthCountryId,
              birthDate: customer.birthDate.substring(0, 10),
              birthPlace: customer.birthPlace,
              comingFromId: customer.comingFromId,
              passportIssuePlace: customer.passportIssuePlace,
              dateOfExpiry: customer.dateOfExpiry.substring(0, 10),
              dateOfIssue: customer.dateOfIssue.substring(0, 10),
              educationId: customer.educationId,
              familyMemberType: customer?.familyMemberType,
              firstName: customer.firstName,
              gender: customer.gender,
              hotelReservationUrl: url + customer.hotelReservationUrl,
              lastName: customer.lastName,
              mainPassportImage: url + customer.mainPassportImage,
              maritalStatusId: customer.maritalStatusId,
              mRZCode: customer.mrzCode,
              nationalityId: customer.nationalityId,
              passport_No: customer.passport_No,
              personalImage: url + customer.personalImage,
              professionId: customer.professionId,
              religionId: customer.religionId,
              returnTicketUrl: url + customer.returnTicketUrl,
              tC_Number: customer.tC_Number,
              visaLanguageId: customer.visaLanguageId,
            };
          }),
        });

        if (data.paymentStatus == 2) {
          this.showType = showTypes.result;
        }
        if (data.paymentStatus < 2 || data.paymentStatus == 3) {
          this.showType = showTypes.payment;
          this.form.patchValue({
            oneTimePaymentApproval:
              localStorage.getItem("oneTimePaymentApproval") === "true"
                ? true
                : false,
          });
        }

        // reset arrivalDate validator
        this.form.get("arrivalDate")?.clearValidators();
        this.form.get("arrivalDate")?.updateValueAndValidity();
        this.showPaymentSection = data.isInvoiceSaved;

        // Yüklenen başvuru için ülke ID'sine göre validasyon ayarla
        if (data.visaCountryId === 51) {
          this.customers.controls.forEach((customer) => {
            customer.get("returnTicketUrl")?.clearValidators();
            customer.get("returnTicketUrl")?.updateValueAndValidity();

            customer.get("hotelReservationUrl")?.clearValidators();
            customer.get("hotelReservationUrl")?.updateValueAndValidity();
          });
        } else {
          this.customers.controls.forEach((customer) => {
            customer
              .get("returnTicketUrl")
              ?.setValidators([Validators.required]);
            customer.get("returnTicketUrl")?.updateValueAndValidity();

            customer
              .get("hotelReservationUrl")
              ?.setValidators([Validators.required]);
            customer.get("hotelReservationUrl")?.updateValueAndValidity();
          });
        }
        this.customers.updateValueAndValidity();
        // Form geneli için de güncelleme (gerekirse)
        this.form.updateValueAndValidity();

        // this.calculatePrice();
        this.getPriceByGuid();
      });
  }
  ngOnDestroy() {
    this.form.reset();
    this.resultPrice = 0;
    this.smsPrice = 0;
    this.cargoPrice = 0;
    this.visaPrice = 0;
    this._visaService.setVisaType({} as VisaSelect);
    this._visaService.setVisaCountry({} as VisaCountry);
    this._visaService.setVisitReason({} as VisaSelect);
  }
  //-------------------------------------------------------------------------------------------------------
  //#region  Modal
  openPreviewImageModal(name: string, index: number) {
    let htValue: string = this.customers
      .at(index)
      .get("hotelReservationUrl")?.value;
    let rtValue: string = this.customers
      .at(index)
      .get("returnTicketUrl")?.value;
    if (htValue !== "" || rtValue !== "") {
      if (name == "hotel-file") {
        let isPdf = htValue.includes("/pdf");
        if (!isPdf) {
          this.imagePreview = htValue;
          this.pdfPreview = "";
        } else {
          this.pdfPreview = htValue;
          this.imagePreview = "";
        }
      }
      if (name == "returnTicket") {
        this.imagePreview = rtValue;
        this.pdfPreview = "";
      }
      this.modalService.open(this.previewImageModal, {
        size: "lg",
      });
    } else {
      this._toast.Error("Lütfen önce bir resim yükleyin.");
    }
  }
  checkShow(name: string, index: number) {
    if (name === "hotel-file") {
      return this.customers.at(index).get("hotelReservationUrl")?.value !== "";
    } else if (name === "returnTicket") {
      return this.customers.at(index).get("returnTicketUrl")?.value !== "";
    }
    return false;
  }
  closePreviewImageModal() {
    this.modalService.dismissAll();
    this.imagePreview = "";
  }
  openModal(content: any) {
    this.modalService.open(content, { centered: true, size: "xl" });
  }
  @ViewChild("photoooInput") photoooInput!: ElementRef<HTMLInputElement>;
  openFileDialog(name: string, index: number, withoutModal = false) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const fileInput = document.getElementsByName(name)[index] as HTMLInputElement;
    if (name === 'passportFile' || name === 'passportFile_1') {
      this.customerIndex$.next(index);
      if (withoutModal) {
        if (fileInput) {
          fileInput.click(); // Trigger the file input
        }
      } else {
        if (index === 0) {
          this.openModal(this.pasaportModal);
        } else {
          fileInput.click();
        }
      }
    } else {
      if (fileInput) {
        fileInput.click(); // Trigger the file input
      }
    }
  }
  closeModal(modal: any, index: number) {
    modal.close();
    const fileInput = document.getElementsByName("passportFile")[
      index
    ] as HTMLInputElement;
    if (fileInput) {
      fileInput.click(); // Trigger the file input
    }
  }
  //#endregion
  //-------------------------------------------------------------------------------------------------------
  page_1_Next(event: fileEvent) {
    this.onFileSelected(event.event, event.name, event.index);
  }
  fileEvent: fileEvent = {} as fileEvent;
  async page_1_onFileSelected(event: Event, name: string) {
    this._spinner.show();
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) {
      const formGroup = this.customers.at(0) as FormGroup;
      const reader = new FileReader();
      // fileType belirle
      let fileType: 'profile' | 'passport' | 'other' | 'pdf' = 'other';
      if (file.type === 'application/pdf') fileType = 'pdf';
      else if (name === 'passportFile_1') fileType = 'passport';
      else if (name === 'personel-photo') fileType = 'profile';
      const resizedFile = await this._imageService.resizeImage(file, fileType);
      const base64 = await this._imageService.fileToBase64(resizedFile);
      if (name === "passportFile_1") {
        this.fileEvent = {
          name: name,
          event: event,
          index: 0,
        };
        formGroup.patchValue({
          mainPassportImage: base64,
        });
      }
      reader.readAsDataURL(file);
    }
    // burada eğer pasaport ve personel resmi yüklendiyse form sayfasına geçiyoruz
    const pasaport = this.customers.at(0).get("mainPassportImage")?.value;
    if (pasaport !== "") {
      this.page_1_Next(this.fileEvent);
    }
  }
  //-------------------------------------------------------------------------------------------------------
  //#region Form işlemleri
  async onFileSelected(event: Event, element: string, index: number) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    // hotel dosya ismi
    const ht_el_text = document.getElementById('hotel-text-' + index) as HTMLObjectElement;
    if (element === 'passportFile' || element === 'passportFile_1') {
      this.customers.at(index).patchValue({
        mRZCode: "",
      });
      this._spinner.show();
      if (this.showType == showTypes.pasaportStep) {
        this.showType = showTypes.form;
      }
    }
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) {
      const reader = new FileReader();
      // check if pdf or image
      const isImage = file.type.startsWith("image/");
      const isPDF = file.type === "application/pdf";
      if (isImage) {
        // fileType belirle
        let fileType: 'profile' | 'passport' | 'other' = 'other';
        if (element === 'personel-photo') fileType = 'profile';
        else if (element === 'passportFile' || element === 'passportFile_1') fileType = 'passport';
        const resizedFile = await this._imageService.resizeImage(file, fileType);
        const base64 = await this._imageService.fileToBase64(resizedFile);
        switch (element) {
          case "passportFile":
          case "passportFile_1":
            this.imagePreview = base64;
            const appformGroup = this.customers.at(index) as FormGroup;
            appformGroup.patchValue({
              mainPassportImage: base64,
            });
            // Burada JS tarafına özel event yolluyoruz
            let htmlInput = document.getElementsByName(element)[
              index
            ] as HTMLInputElement;
            const customEvent = new CustomEvent("MRZFileSelected", {
              detail: {
                index: index,
                input: htmlInput,
              },
            });
            window.dispatchEvent(customEvent);
            break;
          case "personel-photo":
            this.imagePreview = base64;
            const formGroup = this.customers.at(index) as FormGroup;
            formGroup.patchValue({
              personalImage: base64,
            });
            break;
          case "hotel-file":
            const hotelFormGroup = this.customers.at(index) as FormGroup;
            hotelFormGroup.patchValue({
              hotelReservationUrl: base64,
            });
            const fileName = file.name;
            const fileSize = this._helpService.convertBayets(file.size);
            ht_el_text.innerHTML = `<p style="margin: 0;">${fileName}</p><p style="margin: 0;">${fileSize}</p>`;
            break;
          case "returnTicket":
            const rt_el_text = document.getElementById(
              "return-text-" + index,
            ) as HTMLObjectElement;
            const TfileName = file.name;
            const TfileSize = this._helpService.convertBayets(file.size);
            rt_el_text.innerHTML = `<p style="margin: 0;">${TfileName}</p><p style="margin: 0;">${TfileSize}</p>`;
            const returnTicketFormGroup = this.customers.at(index) as FormGroup;
            returnTicketFormGroup.patchValue({
              returnTicketUrl: base64,
            });
            break;
        }
      }
      if (isPDF) {
        const readerPdf = new FileReader();
        readerPdf.readAsDataURL(file);
        readerPdf.onload = () => {
          this.pdfPreview = readerPdf.result;
          if (element === 'hotel-file') {
            const hotelFormGroup = this.customers.at(index) as FormGroup;
            hotelFormGroup.patchValue({
              hotelReservationUrl: readerPdf.result,
            });
          } else if (element === 'returnTicket') {
            const returnTicketFormGroup = this.customers.at(index) as FormGroup;
            returnTicketFormGroup.patchValue({
              returnTicketUrl: readerPdf.result,
            });
          }
        };
        const fileName = file.name;
        const fileSize = this._helpService.convertBayets(file.size);
        if (element === 'hotel-file') {
          ht_el_text.innerHTML = `<p style="margin: 0;">${fileName}</p><p style="margin: 0;">${fileSize}</p>`;
        } else if (element === 'returnTicket') {
          const rt_el_text = document.getElementById(
            "return-text-" + index,
          ) as HTMLObjectElement;
          rt_el_text.innerHTML = `<p style="margin: 0;">${fileName}</p><p style="margin: 0;">${fileSize}</p>`;
        }
      }
      reader.readAsDataURL(file);
      // this._spinner.hide();
    }
  }
  show(showtype: showTypes) {
    this.showType = showtype;
  }
  //#endregion
  //-------------------------------------------------------------------------------------------------------
  calculateVisaDuration(): boolean {
    const arrivalDate = this.form.get("arrivalDate")?.value;
    // get all
    let expirationDates = this.customers.controls.map((item) => {
      return item.get("dateOfExpiry")?.value;
    });
    const arrivalDateObj = new Date(arrivalDate);
    const result: boolean = expirationDates.every((element) => {
      if (element) {
        const expirationDateObj = new Date(element);
        // 6 ayden önce mi kntrol ediyoruz
        const sixMonthsLater = new Date(arrivalDateObj.getFullYear(), arrivalDateObj.getMonth() + 6, arrivalDateObj.getDate());
        if (expirationDateObj < sixMonthsLater) {
          this._toast.Error(
            "Gidiş tarihi ve pasaport bitiş tarihi arasındaki süre 6 aydan az olamaz. Lütfen kontrol edin.",
          );
          return false;
        }
        return true;
      }
      return false;
    });
    return result;
  }
  //-------------------------------------------------------------------------------------------------------
  continue() {
    if (this.isStepValid(1)) {
      // Aile başvurusu kontrolü - en az 2 kişi olmalı 
      const applicationType = this.form.get('applicationType')?.value;
      if (applicationType === 2 && this.customers.length < 2) {
        this._toast.Error("Aile başvurusu için en az 2 kişi eklemeniz gerekmektedir.");
        return;
      }
      // tc kimlik numarasını girildiyse kontrol et ve required yap
      let tcNumbers = this.customers.controls.map((item) => {
        return item.get("tC_Number")?.value;
      });
      let result = tcNumbers.every((item) => {
        if (item) {
          return this._helpService.checkTcNumber(item);
        }
        return true;
      });
      if (!result) {
        this._toast.Error(this.errors.tCNumber);
        return;
      }

      // burada 6 ay sonra kontrolü yapılıyor
      let dateControl = this.calculateVisaDuration();

      if (dateControl) {
        // İletişim kurulacak kişilerin listesini güncelle
        this.contactPersons = this.customers.controls.map(
          (customer, index) => ({
            id: index + 1,
            firstName: customer.get("firstName")?.value,
            lastName: customer.get("lastName")?.value,
            contactCustomerPassport_No: customer.get("passport_No")?.value,
            contactCustomerTC_No: customer.get("tC_Number")?.value,
          }),
        );
        if (this.contactPersons.length > 0) {
          this.form
            .get("contactCustomerPassport_No")
            ?.setValue(this.contactPersons[0].contactCustomerPassport_No);
          this.form
            .get("contactCustomerTC_No")
            ?.setValue(this.contactPersons[0].contactCustomerTC_No);
        }

        this.modalService.open(this.contactModal, {
          centered: true,
          backdrop: "static",
          size: "lg",
        });
      }
    } else {
      this.printFormErrors(this.form);
      this._toast.Error(
        "Lütfen tüm alanları doldurduğunuzdan emin olun ve tekrar deneyin.",
      );
    }
  }
  printFormErrors(control: AbstractControl, parentKey: string = ""): void {
    if (control instanceof FormGroup) {
      Object.keys(control.controls).forEach((key) => {
        const childControl = control.get(key);
        const fullPath = parentKey ? `${parentKey}.${key}` : key;
        if (childControl) {
          this.printFormErrors(childControl, fullPath);
        }
      });
    } else if (control instanceof FormArray) {
      control.controls.forEach((childControl, index) => {
        const fullPath = `${parentKey}[${index}]`;
        this.printFormErrors(childControl, fullPath);
      });
    } else if (control instanceof FormControl && control.invalid) {
    }
  }
  //-------------------------------------------------------------------------------------------------------
  goBack() {
    this.modalService.dismissAll();
    this.showType = showTypes.form;
  }
  //-------------------------------------------------------------------------------------------------------
  ConvertToUpper(event: Event) {
    const input = event.target as HTMLInputElement;
    const upperValue = input.value.toUpperCase();
    input.value = upperValue;
  }
  //-------------------------------------------------------------------------------------------------------
  async saveAndContinue() {
    this.form.get("applicationType")?.valueChanges.subscribe((value) => {
      const familyMembershipControl = this.customers
        .at(0)
        .get("familyMemberType");

      if (value === 2) {
        // Aile başvurusuysa: Zorunlu
        familyMembershipControl?.setValidators([Validators.required]);
      } else if (value === 1) {
        // Bireysel başvuruysa: Zorunlu değil
        familyMembershipControl?.clearValidators();
      }

      familyMembershipControl?.updateValueAndValidity();
    });

    const url = environment.apiUrl + "/VisaApplication";
    if (this.form.valid) {
      // remove apllicationNumber
      // this.form.removeControl('apllicationNumber');
      await firstValueFrom(this._http.post(url, this.form.value)).then((response: any) => {
        this.visaApplicationGuid = response.id;
        this.visaApplicationNumber = response.apllicationNumber;
        this.getById(this.visaApplicationGuid);
        if (response) {
          this.modalService.dismissAll();

          this.router.navigate(["/visa"], {
            queryParams: {
              id: this.visaApplicationGuid,
            },
          });
          this.showType = showTypes.payment;
        }
      },
      );
    } else {
      this._toast.Error(
        "Lütfen tüm alanları doldurduğunuzdan emin olun ve tekrar deneyin.",
      );
      this.getFormErrors();
    }
  }
  //-------------------------------------------------------------------------------------------------------
  checkType(type: invoiceTypes) {
    this.invoiceType = type;
    this.form.get("invoiceType")?.setValue(type);
    if (type == invoiceTypes.corporate) {
      this.form.patchValue({
        invoice_TCNumber: "",
      });
    }
    if (type == invoiceTypes.individual) {
      this.form.patchValue({
        invoice_Title: null,
        invoice_TaxNumber: null,
        invoice_TaxOffice: null,
      });
    }
  }
  //-------------------------------------------------------------------------------------------------------
  showPaymentSection: boolean = false; // Ödeme bölümünün görünürlüğünü kontrol
  updateInvoice() {
    const ispaymentApprovalChecked = this.form.get(
      "oneTimePaymentApproval",
    )?.value;
    if (!ispaymentApprovalChecked) {
      this._toast.Error(
        "Lütfen mesafeli satış sözleşmesini okuduğunuzdan ve onayladığınızdan emin olun.",
      );

      return;
    }

    const url = environment.apiUrl + '/VisaApplication/UpdateInvoice';
    const type = this.form.get('invoiceType')?.value;
    const obj = {
      guid: this.visaApplicationGuid || this.form.get("guid_Id")?.value,
      invoiceType: type,
      invoice_FirstName: this.form.get("invoice_FirstName")?.value,
      invoice_City: this.form.get("invoice_City")?.value,
      invoice_District: this.form.get("invoice_District")?.value,
      invoice_LastName: this.form.get("invoice_LastName")?.value,
      invoice_Title: this.form.get("invoice_Title")?.value,
      invoice_Address: this.form.get("invoice_Address")?.value,
      invoice_TaxNumber: this.form.get("invoice_TaxNumber")?.value,
      invoice_TaxOffice: this.form.get("invoice_TaxOffice")?.value,
      invoice_TCNumber: this.form.get("invoice_TCNumber")?.value,
      deliveryAddress: this.form.get("deliveryAddress")?.value,
      sendSMS: this.form.get("sendSMS")?.value,
      sendCargo: this.form.get("sendCargo")?.value,
    };
    if (type == invoiceTypes.corporate) {
      this.form.get("invoice_Title")?.setValidators([Validators.required]);
      this.form.get("invoice_TaxNumber")?.setValidators([Validators.required]);
      this.form.get("invoice_TaxOffice")?.setValidators([Validators.required]);
      this.form.get("invoice_Address")?.setValidators([Validators.required]);
      this.form.get("invoice_City")?.setValidators([Validators.required]);
      this.form.get("invoice_District")?.setValidators([Validators.required]);

      // Gereksiz alanları temizle
      this.form.get("invoice_TCNumber")?.clearValidators();
      this.form.get("invoice_FirstName")?.clearValidators();
      this.form.get("invoice_LastName")?.clearValidators();

      // Tüm alanlar için validiteyi güncelle
      this.form.get("invoice_Title")?.updateValueAndValidity();
      this.form.get("invoice_TaxNumber")?.updateValueAndValidity();
      this.form.get("invoice_TaxOffice")?.updateValueAndValidity();
      this.form.get("invoice_Address")?.updateValueAndValidity();
      this.form.get("invoice_City")?.updateValueAndValidity();
      this.form.get("invoice_District")?.updateValueAndValidity();
    }
    if (type == invoiceTypes.individual) {
      // add required to invoice_TCNumber
      this.form.controls["invoice_Title"]?.clearValidators();
      this.form.controls["invoice_Title"].updateValueAndValidity();
      this.form.controls["invoice_TaxNumber"]?.clearValidators();
      this.form.controls["invoice_TaxNumber"].updateValueAndValidity();
      this.form.controls["invoice_TaxOffice"]?.clearValidators();
      this.form.controls["invoice_TaxOffice"].updateValueAndValidity();

      // Fatura TC kimlik numarası için ilk müşterinin uyruğunu kontrol et.
      const firstCustomer = this.customers.at(0) as FormGroup;
      const nationalityId = firstCustomer.get("nationalityId")?.value;

      if (nationalityId === 792) {
        this.form.controls["invoice_TCNumber"]?.setValidators([
          Validators.required,
          Validators.minLength(11),
          Validators.maxLength(11),
          this.tcNumberValidator(nationalityId),
        ]);
      } else {
        this.form.controls["invoice_TCNumber"]?.clearValidators();
        this.form.controls["invoice_TCNumber"]?.setErrors(null);
        this.form.controls["invoice_TCNumber"]?.markAsUntouched();
      }
      this.form.controls['invoice_TCNumber'].updateValueAndValidity();
      
      this.form.controls['invoice_FirstName']?.setValidators([Validators.required]);
      this.form.controls['invoice_District']?.setValidators([Validators.required]);
      this.form.controls['invoice_City']?.setValidators([Validators.required]);
      this.form.controls['invoice_LastName']?.setValidators([Validators.required]);
      this.form.controls['invoice_Address']?.setValidators([Validators.required]);
      this.form.controls['invoice_FirstName'].updateValueAndValidity();
      this.form.controls['invoice_District'].updateValueAndValidity();
      this.form.controls['invoice_City'].updateValueAndValidity();
      this.form.controls['invoice_LastName'].updateValueAndValidity();
      this.form.controls['invoice_Address'].updateValueAndValidity();
    }
    if (this.form.valid) {
      this._http.post(url, obj).subscribe((response) => {
        // if response is true, then show payment section
        if (response) {
          this.getById(this.visaApplicationGuid || this.form.get('guid_Id')?.value);
          this.showPaymentSection = true;
          this._toast.Success('Fatura bilgileri başarıyla kaydedildi.');
        }
        else {
          this._toast.Error('Fatura bilgileri kaydedilemedi. Lütfen tekrar deneyin.');
          this.showPaymentSection = false;
        }
      });
      this.showPaymentSection = true;
    } else {
      this._toast.Error(
        "Lütfen tüm alanları doldurduğunuzdan emin olun ve tekrar deneyin.",
      );
      this.showPaymentSection = false;
      // log errors
      this.getFormErrors();
      // form

      return;
    }
  }

  selectPaymentType(type: 'creditCard' | 'transfer') {
    this.paymentType = type;

    if (type === 'creditCard') {
      this.updatePaymentStatus(1); // Pending
    } else if (type === 'transfer') {
      this.updatePaymentStatus(4); // BankPaymentPending
    }
  }

  updatePaymentStatus(paymentStatus: number): void {
  const guid = this.form.get("guid_Id")?.value;

  if (!guid) {
    this._toast.Info("Başvuru GUID bulunamadı.");
    return;
  }

  const dto = {
    guid: guid,
    paymentStatus: paymentStatus
  };

  this._http.post(`${environment.apiUrl}/VisaApplication/UpdatePaymentStatus`, dto).subscribe({
    next: () => {
      console.log("Ödeme durumu güncellendi:", paymentStatus);
      this._toast.Success("Ödeme durumu başarıyla güncellendi.");
    },
    error: (err) => {
      console.error("Ödeme durumu güncellenirken hata oluştu:", err);
      this._toast.Error("Ödeme durumu güncellenirken hata oluştu.");
    }
  });
}
  //-------------------------------------------------------------------------------------------------------
  getFormErrors() {
    Object.keys(this.form.controls).forEach((key) => {
      const control = this.form.get(key);
      if (control && control.invalid) {
        // if control is list
        if (control instanceof FormArray) {
          control.controls.forEach((item, index) => {
            if (item instanceof FormGroup) {
              Object.keys(item.controls).forEach((ctrlKey) => {
                const ctrl = item.get(ctrlKey);
                if (ctrl && ctrl.invalid) {
                  console.error(
                    `FormArray[${index}].${ctrlKey} invalid:`,
                    ctrl.errors,
                  );
                }
              });
            }
          });
        }
        else {

        }
      }
    });
  }
  //-------------------------------------------------------------------------------------------------------
  reUpdateInvoice() {
    this.showPaymentSection = false;
  }
  //-------------------------------------------------------------------------------------------------------
  //#region payment

  checkCardFormValidity(): boolean {
    const cardHolder = (document.querySelector('input[autocomplete="cc-name"]') as HTMLInputElement)?.value?.trim();
    const cardNumber = (document.querySelector('input[autocomplete="cc-number"]') as HTMLInputElement)?.value?.trim();
    const cvv = (document.querySelector('input[autocomplete="cc-csc"]') as HTMLInputElement)?.value?.trim();
    const expMonth = (document.querySelector('select[autocomplete="cc-exp-month"]') as HTMLSelectElement)?.value;
    const expYear = (document.querySelector('select[autocomplete="cc-exp-year"]') as HTMLSelectElement)?.value;

    this.isCardFormValid =
      !!cardHolder &&
      !!cardNumber &&
      !!cvv &&
      !!expMonth &&
      !!expYear;

    return this.isCardFormValid;
  }

  processPayment() {
    const cardNumberInput = (document.querySelector('input[autocomplete="cc-number"]') as HTMLInputElement)?.value?.replace(/\D/g, "");
    if (!this.isValidCardNumber(cardNumberInput)) {
      this._toast.Error("Geçersiz kart numarası girdiniz. Lütfen kontrol ediniz.");
      return;
    }
    if (!this.checkCardFormValidity()) {
      this._toast.Error("Lütfen tüm kart bilgilerini eksiksiz doldurun.");
      return;
    }
    this.modalService.open(this.paymentModal, {
      centered: true,
      size: "xl",
      backdrop: "static",
    });
    const url = environment.apiUrl + "/Payment";
    const obj = {
      amount: this.resultPrice,
      trAmount: this.resultPriceTRY,
      installment: "1",
      currencyCode: this.currency_code,
      cc_holder_name: this.cc_holder_name,
      credit_card_no: this.credit_card_no.replace(/\s/g, ""), // remove spaces
      expiry_month: this.expiry_month,
      expiry_year: this.expiry_year,
      cvv: this.cvv,
      visaApplicationGuid:
        this.visaApplicationGuid || this.form.get("guid_Id")?.value,
      paymentMethod: 1,
    };

    // set iframge as html page

    this._http
      .post(url, obj, {
        responseType: "text",
        headers: {
          "Content-Type": "application/json",
          Accept: "text/html",
        },
      })
      .subscribe((response: any) => {
        setTimeout(() => {
          const iframe = this.iframeRef?.nativeElement;
          if (!iframe) {
            console.warn("iframe henüz hazır değil");
            return;
          }

          const doc = iframe.contentWindow?.document;
          if (doc) {
            doc.open();
            doc.write(response);
            doc.close();
          }
        }, 100);
      });
  }
  processTransferPayment() {
    const isInvoiceSaved = this.form.get("isInvoiceSaved")?.value;
    if (!isInvoiceSaved) {
      this._toast.Error("Lütfen önce fatura bilgilerini doldurun ve kaydedin.");
      return;
    }
    this.show(showTypes.result);
    this._toast.Success(
      "Ödeme havale olarak alınacaktır. Lütfen yarım saat içinde havalenizi yapınız.",
      7000,
    );
  }
  //#endregion
  //-------------------------------------------------------------------------------------------------------
  // Kart numarası formatlama
  formatCardNumber(event: any) {
    let value = event.target.value.replace(/\D/g, "");
    // Sadece 16 hane olduğunda kontrol et
    if (value.length === 16) {
      if (!this.isValidCardNumber(value)) {
        this._toast.Error("Geçersiz kart numarası girdiniz. Lütfen kontrol ediniz.");
      }
    }
    let length = value.length;
    const visaUrl =
      "https://www.freepnglogos.com/uploads/visa-logo-icon-30.png";
    const cardApi = environment.apiUrl + "/VisaApplication/GetCardInfo";
    if (length >= 6) {
      this._http.get(cardApi + '/' + value.substring(0, 6), { headers: { skipLoad: 'true' } }).subscribe((response: any) => {
        if (response) {
          let iconHtml = document.getElementById('card-icon') as HTMLObjectElement;
          switch (response.brand) {
            case 'VISA':
              iconHtml.innerHTML = `<img src="${visaUrl}" alt="Visa" width="50px" height="30px" style="object-fit: contain;"/>`;
              break;
            case 'MASTERCARD':
              iconHtml.innerHTML = `<img src="https://www.freepnglogos.com/uploads/mastercard-png/mastercard-logo-transparent-png-stickpng-10.png" alt="MasterCard" width="50px" height="30px" style="object-fit: contain;"/>`;
              break;
            case 'AMERICAN EXPRESS':
              iconHtml.innerHTML = `<img src="https://www.americanexpress.com/content/dam/amex/us/merchant/supplies-uplift/product/images/img-WEBLOGO1-01.jpg" alt="American Express" width="50px" height="30px" style="object-fit: contain;"/>`;
              break;
          }
        }
      });
    }
    value = value.replace(/(.{4})/g, "$1 ").trim();
    event.target.value = value;
    this.credit_card_no = value;
  }
  formatCardHolder(event: any) {
    const value = event.target.value.replace(/[^a-zA-Z\s]/g, "");
    event.target.value = value.toUpperCase();
    this.cc_holder_name = value;
  }
  onMonthChange(event: any) {
    const month: string = event.target.value;
    if (month) {
      // Ayı iki haneli formatta sakla
      this.expiry_month = month.padStart(2, "0");
      // this.expiryMonth = month;
    }
  }
  onYearChange(event: any) {
    const year: string = event.target.value;
    if (year) {
      this.expiry_year = year.slice(2, 4);
    }
  }
  formatNumberInput(event: any, name?: string) {
    const value = event.target.value.replace(/\D/g, "");
    event.target.value = value;
    if (name == "cvv") {
      this.cvv = value;
    }
  }
  //-------------------------------------------------------------------------------------------------------
  //#region Form Submit
  formSubmit() { }
  //#endregion
  //-------------------------------------------------------------------------------------------------------
  async loadBanks() {
    try {
      this.banks = await this.bankService.getBankaInfo();
    } catch (error) {
      console.error("Banka bilgileri alınamadı:", error);
    }
  }

  copyToClipboard(text: string) {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        // Kopyalama başarılı olduğunda kullanıcıya bilgi ver
        this._toast.Success("IBAN Kopyalandı!");
      })
      .catch((err) => {
        // Hata durumunda kullanıcıya bilgi ver
        this._toast.Error("Kopyalanırken bir hata oluştu!");
      });
  }
  openDatePicker(input: HTMLInputElement) {
    if ("showPicker" in input) {
      (input as any).showPicker(); // modern tarayıcılar için
    }
  }

  getTodayDate(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  // TC Kimlik Numarası Validasyonu
  checkNationalityNumber(
    value: string,
    countryId: number,
    isRequired: boolean,
  ): boolean {
    if (!isRequired) return true;
    if (countryId != 792 || countryId == null) return true;

    if (value && value.length == 11) {
      // ilk hane sıfır olamaz
      let control1 = value.substr(0, 1) != "0";

      // ilk 10 hane kontrol
      let total1 = 0;
      for (let i = 0; i < 10; i++) {
        total1 += parseInt(value[i]);
      }
      let control2 = total1 % 10 == parseInt(value.substr(10, 1));

      // 1, 3, 5, 7, 9 basamaklar ve 2, 4, 6, 8 basamaklar kontrol
      let totalOdd = 0;
      let totalEven = 0;
      for (let i = 0; i < 10; i += 2) {
        totalOdd += parseInt(value[i]);
      }
      for (let i = 1; i < 9; i += 2) {
        totalEven += parseInt(value[i]);
      }
      let result = (totalOdd * 7 - totalEven) % 10;
      if (result < 0) result += 10;
      let control3 = result % 10 == parseInt(value.substr(9, 1));

      // son rakam çift
      let control4 = parseInt(value.substr(10, 1)) % 2 == 0;

      return control1 && control2 && control3 && control4;
    } else {
      return false;
    }
  }

  // TC Kimlik Numarası Custom Validator
  tcNumberValidator(countryId: number) {
    return (control: any) => {
      const value = control.value;
      // Eğer değer boşsa ve Türk vatandaşı değilse
      if (!value && countryId !== 792) {
        return null;
      }
      // Eğer değer boşsa ve Türk vatandaşı ise, required validator zaten kontrol edecek
      if (!value) {
        return null;
      }
      // Sadece Türk vatandaşları için TC validasyonu
      if (countryId === 792) {
        // Eğer değer girilmeye başlandıysa (1 veya daha fazla karakter)
        if (value.length > 0) {
          // İlk hane sıfır olamaz kontrolü
          if (value.length >= 1 && value[0] === "0") {
            return { tcknInvalid: true };
          }

          // 11 hane tamamlandığında tam validasyon yap
          if (value.length === 11) {
            const isValid = this.checkNationalityNumber(value, countryId, true);
            if (!isValid) {
              return { tcknInvalid: true };
            }
          }
          // 11 hane tamamlanmadıysa da geçersiz olarak işaretle
          else {
            return { tcknInvalid: true };
          }
        }
      }

      return null;
    };
  }

  // TC Kimlik Numarası onChange
  onTCNumberChange(event: any, customerIndex: number) {
    const value = event.target.value.replace(/\D/g, "");
    event.target.value = value;

    const customer = this.customers.at(customerIndex) as FormGroup;
    const nationalityId = customer.get("nationalityId")?.value;
    const tcNumberControl = customer.get("tC_Number");

    // TC kimlik numarası sadece Türk vatandaşları için zorunlu
    if (nationalityId === 792) {
      tcNumberControl?.setValidators([
        Validators.required,
        Validators.minLength(11),
        Validators.maxLength(11),
        this.tcNumberValidator(nationalityId),
      ]);
    } else {
      tcNumberControl?.clearValidators();
      tcNumberControl?.setErrors(null); // Hataları da temizle
      tcNumberControl?.markAsUntouched(); // Touched durumunu da temizle
    }
    tcNumberControl?.updateValueAndValidity();
    this.form.updateValueAndValidity();
  }

  onNationalityChange(customerIndex: number) {
    const customer = this.customers.at(customerIndex) as FormGroup;
    const nationalityId = customer.get("nationalityId")?.value;
    const tcNumberControl = customer.get("tC_Number");

    if (nationalityId !== 792) {
      tcNumberControl?.clearValidators();
      tcNumberControl?.setErrors(null);
      tcNumberControl?.markAsUntouched();
      tcNumberControl?.updateValueAndValidity();
    }
  }

  // Fatura TC Kimlik Numarası onChange
  onInvoiceTCNumberChange(event: any) {
    const value = event.target.value.replace(/\D/g, "");
    event.target.value = value;

    const firstCustomer = this.customers.at(0) as FormGroup;
    const nationalityId = firstCustomer.get("nationalityId")?.value;
    const invoiceTCNumberControl = this.form.get("invoice_TCNumber");

    // TC kimlik numarası sadece Türk vatandaşları için zorunlu
    if (nationalityId === 792) {
      invoiceTCNumberControl?.setValidators([
        Validators.required,
        Validators.minLength(11),
        Validators.maxLength(11),
        this.tcNumberValidator(nationalityId),
      ]);
    } else {
      invoiceTCNumberControl?.clearValidators();
      invoiceTCNumberControl?.setErrors(null); // Hataları da temizle
      invoiceTCNumberControl?.markAsUntouched(); // Touched durumunu da temizle
    }

    invoiceTCNumberControl?.updateValueAndValidity();
    this.form.updateValueAndValidity();
  }

  // Luhn algoritması ile kredi kartı numarası doğrulama
  isValidCardNumber(cardNumber: string): boolean {
    const value = cardNumber.replace(/\D/g, "");
    let sum = 0;
    let shouldDouble = false;
    for (let i = value.length - 1; i >= 0; i--) {
      let digit = parseInt(value.charAt(i), 10);
      if (shouldDouble) {
        digit *= 2;
        if (digit > 9) digit -= 9;
      }
      sum += digit;
      shouldDouble = !shouldDouble;
    }
    return sum % 10 === 0;
  }
}
export enum showTypes {
  firstStep,
  pasaportStep,
  form,
  contact,
  payment,
  result,
}
export enum childTypes {
  country,
  visaReason,
  visaType,
}
export enum invoiceTypes {
  individual,
  corporate,
}
export interface fileEvent {
  event: Event;
  name: string;
  index: number;
}
